import { renderLucideIcon } from '../utils/lucide-icons.js'

function normalizeDictationActivityDraftUi(result) {
  if (!result || typeof result !== 'object') return null

  var ui = result.ui || result.dictationActivityDraftUi || null
  if (!ui || typeof ui !== 'object') return null
  if (String(ui.type || '').toLowerCase() !== 'dictation-activity-draft') return null

  var activity = normalizeActivity(ui.activity)
  if (!activity) return null

  return {
    type: 'dictation-activity-draft',
    title: String(ui.title || 'Action à valider'),
    message: String(ui.message || '').trim(),
    error: normalizeError(ui.error || result.error),
    activity: activity,
    typeOptions: normalizeTypeOptions(ui.typeOptions),
    links: normalizeLinks(ui.links),
    associatedRecord: normalizeAssociatedRecord(ui.associatedRecord, ui.links),
    origins: normalizeOrigins(ui.origins),
    labels: normalizeLabels(ui.labels),
    nextStepKey: String(ui.nextStepKey || 'DictationExecute')
  }
}

function renderDictationActivityDraftUi(ui) {
  var error = ui.error
    ? '<div class="wc-dictation-activity-error" data-dictation-activity-error-field="' + escapeAttributeValue(ui.error.field || '') + '">' + renderLucideIcon('triangleAlert') + '<span>' + escapeHtml(ui.error.message || '') + '</span></div>'
    : ''

  return (
    '<div class="wc-dictation-activity-ui" data-ds-view="dictation-activity-draft">' +
      '<div class="wc-ds-capability wc-ds-capability-dictation">' +
        '<div class="wc-ds-capability-name">' + renderLucideIcon('mic') + '<span>' + escapeHtml(ui.labels.capability || '@Dictée') + '</span></div>' +
        '<div class="wc-ds-capability-meta">' + escapeHtml(ui.title || 'Action à valider') + '</div>' +
      '</div>' +
      '<form class="wc-dictation-activity-form">' +
        '<div class="wc-dictation-activity-head">' +
          '<div class="wc-dictation-activity-title">' + escapeHtml(ui.title || 'Action à valider') + '</div>' +
          (ui.message ? '<div class="wc-dictation-activity-message">' + escapeHtml(ui.message) + '</div>' : '') +
        '</div>' +
        error +
        '<div class="wc-dictation-activity-grid">' +
          '<label class="wc-dictation-activity-field">' +
            '<span class="wc-dictation-activity-label-row"><span>' + escapeHtml(ui.labels.activityType || "Type d'activité") + '</span>' + renderOriginBadge(ui.origins.activity.type, ui.labels) + '</span>' +
            '<select data-dictation-activity-type>' +
              ui.typeOptions.map(function (option) {
                return '<option value="' + escapeAttributeValue(option.value) + '"' + (option.value === ui.activity.type ? ' selected' : '') + '>' + escapeHtml(option.label) + '</option>'
              }).join('') +
            '</select>' +
          '</label>' +
          '<label class="wc-dictation-activity-field">' +
            '<span class="wc-dictation-activity-label-row"><span>' + escapeHtml(ui.labels.deadline || 'Échéance simple') + '</span>' + renderOriginBadge(ui.origins.activity.startAt, ui.labels) + '</span>' +
            '<input type="datetime-local" data-dictation-activity-start-at value="' + escapeAttributeValue(formatDateTimeLocal(ui.activity.startAt)) + '">' +
            (ui.activity.type === 'meeting' ? '<span class="wc-dictation-activity-label-row"><span>Heure de fin</span></span><input type="datetime-local" data-dictation-activity-end-at value="' + escapeAttributeValue(formatDateTimeLocal(ui.activity.endAt)) + '">' : '') +
          '</label>' +
        '</div>' +
        '<label class="wc-dictation-activity-field">' +
          '<span class="wc-dictation-activity-label-row"><span>' + escapeHtml(ui.labels.title || 'Libellé') + '</span>' + renderOriginBadge(ui.origins.activity.title, ui.labels) + '</span>' +
          '<input type="text" data-dictation-activity-title value="' + escapeAttributeValue(ui.activity.title || '') + '" maxlength="160">' +
        '</label>' +
        '<label class="wc-dictation-activity-field">' +
          '<span class="wc-dictation-activity-label-row"><span>' + escapeHtml(ui.labels.comment || 'Description') + '</span>' + renderOriginBadge(ui.origins.activity.comment, ui.labels) + '</span>' +
          '<textarea data-dictation-activity-comment rows="5" maxlength="1000">' + escapeHtml(ui.activity.comment || '') + '</textarea>' +
        '</label>' +
        renderAssociatedRecord(ui) +
        '<div class="wc-dictation-activity-actions">' +
          '<button type="submit" class="wc-dictation-activity-confirm">' + renderLucideIcon('check') + '<span>' + escapeHtml(ui.labels.confirm || "Créer l'activité") + '</span></button>' +
        '</div>' +
      '</form>' +
    '</div>'
  )
}

function bindDictationActivityDraftUi(el, ui, handlers) {
  if (!el || !ui) return
  var form = el.querySelector('.wc-dictation-activity-form')
  if (!form) return

  form.addEventListener('submit', function (event) {
    event.preventDefault()
    if (!handlers || typeof handlers.onConfirm !== 'function') return

    handlers.onConfirm({
      nextStepKey: ui.nextStepKey || 'DictationExecute',
      label: ui.labels.confirm || "Créer l'activité",
      activity: {
        type: readValue(el, '[data-dictation-activity-type]'),
        title: readValue(el, '[data-dictation-activity-title]'),
        comment: readValue(el, '[data-dictation-activity-comment]'),
        startAt: readValue(el, '[data-dictation-activity-start-at]'),
        endAt: readValue(el, '[data-dictation-activity-end-at]')
      },
      links: {
        entityId: ui.links.entityId || null,
        contactId: ui.links.contactId || null,
        dealId: ui.links.dealId || null
      }
    })
  })
}

function renderAssociatedRecord(ui) {
  var record = ui.associatedRecord
  if (!record) return ''
  var typeLabel = resolveAssociatedRecordTypeLabel(record.objectType, ui.labels)
  var origin = record.objectType === 'entity'
    ? ui.origins.links.entityId
    : record.objectType === 'contact'
      ? ui.origins.links.contactId
      : ui.origins.links.dealId

  return (
    '<div class="wc-dictation-activity-linked-record" data-dictation-activity-associated-record="' + escapeAttributeValue(record.objectType) + '">' +
      '<div class="wc-dictation-activity-linked-record-head">' +
        '<span>' + renderLucideIcon('gitBranch') + escapeHtml(ui.labels.linkedRecords || 'Objet associé') + '</span>' +
        renderOriginBadge(origin, ui.labels) +
      '</div>' +
      '<div class="wc-dictation-activity-linked-record-body">' +
        '<span class="wc-dictation-activity-linked-record-type">' + escapeHtml(typeLabel) + '</span>' +
        '<span class="wc-dictation-activity-linked-record-label">' + escapeHtml(record.label) + '</span>' +
      '</div>' +
    '</div>'
  )
}

function resolveAssociatedRecordTypeLabel(objectType, labels) {
  if (objectType === 'entity') return labels.entity || 'Compte'
  if (objectType === 'contact') return labels.contact || 'Contact'
  return labels.deal || 'Opportunité'
}

function renderOriginBadge(origin, labels) {
  if (!origin) return ''
  var label = origin === 'explicit'
    ? labels.originExplicit
    : origin === 'context'
      ? labels.originContext
      : labels.originInferred
  return '<span class="wc-dictation-activity-origin" data-dictation-origin="' + escapeAttributeValue(origin) + '">' + escapeHtml(label) + '</span>'
}

function normalizeActivity(value) {
  if (!value || typeof value !== 'object') return null
  return {
    type: normalizeActivityType(value.type),
    title: String(value.title || '').trim(),
    comment: String(value.comment || '').trim(),
    startAt: String(value.startAt || '').trim(),
    endAt: String(value.endAt || '').trim()
  }
}

function normalizeTypeOptions(value) {
  var options = Array.isArray(value)
    ? value.map(function (option) {
      if (!option || typeof option !== 'object') return null
      var optionValue = normalizeActivityType(option.value)
      var label = String(option.label || '').trim()
      return optionValue && label ? { value: optionValue, label: label } : null
    }).filter(Boolean)
    : []

  return options.length ? options : [
    { value: 'task', label: 'Tâche' },
    { value: 'follow_up', label: 'Relance' },
    { value: 'call', label: 'Appel' },
    { value: 'meeting', label: 'Rendez-vous' },
    { value: 'other', label: 'Autre' }
  ]
}

function normalizeActivityType(value) {
  var normalized = String(value || '').trim()
  return ['task', 'follow_up', 'call', 'meeting', 'other'].indexOf(normalized) >= 0 ? normalized : 'task'
}

function normalizeLinks(value) {
  value = value && typeof value === 'object' ? value : {}
  return {
    entityId: String(value.entityId || '').trim(),
    contactId: String(value.contactId || '').trim(),
    dealId: String(value.dealId || '').trim()
  }
}

function normalizeAssociatedRecord(value, links) {
  value = value && typeof value === 'object' ? value : null
  if (value) {
    var objectType = normalizeAssociatedRecordObjectType(value.objectType)
    var recordId = String(value.recordId || '').trim()
    var label = String(value.label || '').trim()
    if (objectType && recordId) {
      return {
        objectType: objectType,
        recordId: recordId,
        label: label || formatAssociatedRecordFallback(objectType, recordId)
      }
    }
  }

  links = normalizeLinks(links)
  if (links.dealId) return { objectType: 'deal', recordId: links.dealId, label: formatAssociatedRecordFallback('deal', links.dealId) }
  if (links.contactId) return { objectType: 'contact', recordId: links.contactId, label: formatAssociatedRecordFallback('contact', links.contactId) }
  if (links.entityId) return { objectType: 'entity', recordId: links.entityId, label: formatAssociatedRecordFallback('entity', links.entityId) }
  return null
}

function normalizeAssociatedRecordObjectType(value) {
  var normalized = String(value || '').trim().toLowerCase()
  if (normalized === 'entity' || normalized === 'account' || normalized === 'company') return 'entity'
  if (normalized === 'contact' || normalized === 'person') return 'contact'
  if (normalized === 'deal' || normalized === 'opportunity') return 'deal'
  return ''
}

function formatAssociatedRecordFallback(objectType, recordId) {
  void recordId
  var label = objectType === 'entity' ? 'Compte' : objectType === 'contact' ? 'Contact' : 'Opportunité'
  return objectType === 'deal' ? label + ' associée' : label + ' associé'
}

function normalizeOrigins(value) {
  value = value && typeof value === 'object' ? value : {}
  var activity = value.activity && typeof value.activity === 'object' ? value.activity : {}
  var links = value.links && typeof value.links === 'object' ? value.links : {}
  return {
    activity: {
      type: normalizeOrigin(activity.type) || 'inferred',
      title: normalizeOrigin(activity.title) || 'inferred',
      comment: normalizeOrigin(activity.comment) || 'inferred',
      startAt: normalizeOrigin(activity.startAt)
    },
    links: {
      entityId: normalizeOrigin(links.entityId),
      contactId: normalizeOrigin(links.contactId),
      dealId: normalizeOrigin(links.dealId)
    }
  }
}

function normalizeOrigin(value) {
  var normalized = String(value || '').trim()
  return normalized === 'explicit' || normalized === 'inferred' || normalized === 'context' ? normalized : null
}

function normalizeError(value) {
  if (!value || typeof value !== 'object') return null
  var message = String(value.message || '').trim()
  if (!message) return null
  return {
    field: String(value.field || '').trim(),
    message: message
  }
}

function normalizeLabels(value) {
  value = value && typeof value === 'object' ? value : {}
  return {
    capability: String(value.capability || '@Dictée'),
    activityType: String(value.activityType || "Type d'activité"),
    title: String(value.title || 'Libellé'),
    comment: String(value.comment || 'Description'),
    deadline: String(value.deadline || 'Échéance simple'),
    linkedRecords: String(value.linkedRecords || 'Objets liés'),
    entity: String(value.entity || 'Compte'),
    contact: String(value.contact || 'Contact'),
    deal: String(value.deal || 'Opportunité'),
    originExplicit: String(value.originExplicit || 'Fourni'),
    originInferred: String(value.originInferred || 'Déduit'),
    originContext: String(value.originContext || 'Contexte'),
    confirm: String(value.confirm || "Créer l'activité")
  }
}

function readValue(el, selector) {
  var input = el.querySelector(selector)
  return input ? String(input.value || '').trim() : ''
}

function formatDateTimeLocal(value) {
  var raw = String(value || '').trim()
  if (!raw) return ''
  var date = new Date(raw)
  if (Number.isNaN(date.getTime())) return raw
  return date.toISOString().slice(0, 16)
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function escapeAttributeValue(value) {
  return escapeHtml(value).replace(/`/g, '&#96;')
}

export {
  bindDictationActivityDraftUi,
  normalizeDictationActivityDraftUi,
  renderDictationActivityDraftUi
}
